import { render } from "./LangSwitcher.vue?vue&type=template&id=4bf09afc"
import script from "./LangSwitcher.vue?vue&type=script&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&lang=js"

import "./LangSwitcher.vue?vue&type=style&index=0&id=4bf09afc&lang=less"

import exportComponent from "/Users/alex/Documents/Google Ads/Panorama Residence/Panorama web/panorama-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__